import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8">
            <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
              About Home Fashion Varanasi
            </span>
          </h1>
          
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
            <p className="text-gray-600 leading-relaxed mb-4">
              Welcome to Home Fashion, your premier destination for quality home furnishings in the heart of Varanasi. Located on Rathyatra-Mahmmoorganj Road, we have been serving the local community since 2010.
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Our showroom features a wide range of furniture, home decor, and accessories that blend traditional craftsmanship with modern design. Whether you're furnishing a new home or redecorating an existing space, our collection has something for every style and budget.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We take pride in our personalized customer service and are always happy to help you find the perfect pieces for your home. Visit us today at Rathyatra-Mahmmoorganj Road and experience the Home Fashion difference!
            </p>
          </div>

          <div className="bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-2xl shadow-xl p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Visit Our Showroom</h2>
            <p className="mb-2">Rathyatra-Mahmmoorganj Road, Varanasi</p>
            <p className="mb-2">Call us: 8573035759</p>
            <p>Open Mon-Sat: 10am - 8pm</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;